import Component from 'ShopUi/models/component';
import { TrackProductClickConfigProductWithPrices, buildConfigProduct, pushProductClickToDataLayer } from 'PyzShopUi/scripts/shop-ui/services/ProductClickTrackingService';
import { UNKNOWN_LIST_NAME } from 'PyzShopUi/scripts/shop-ui/components/product-item/ProductItemListNameContext';
import { setScrollCommand } from 'PyzShopUi/scripts/shop-ui/services/ScrollBackService';

const TRACKING_NAME = 'tracking';
const DATA_TRACKING_ATTRIBUTE_NAME = `data-${TRACKING_NAME}`;
const PRODUCTS_TITLE_CLASS_NAME = 'page-layout-catalog-header';
const BIKE_DB_CONTAINER_CLASS_NAME = 'bike-detail-page-container';
const BIKE_DB_ID = 'Bike-DB';

export default class ProductItem extends Component {
    protected readyCallback(): void {
    }

    /**
     * This function will return which product list is currently displayed
     * This is used within the tracking data pushed to window.dataLayer
     */
    getListName() {
        const listHeadlineElement: HTMLHeadingElement = document.querySelector(`h1[class="${PRODUCTS_TITLE_CLASS_NAME}"]`);
        const bikeContainerElement: HTMLDivElement = document.querySelector(`div[class="${BIKE_DB_CONTAINER_CLASS_NAME}"]`);

        if (listHeadlineElement) {
            return listHeadlineElement.innerText;
        }

        if (bikeContainerElement) {
            return BIKE_DB_ID;
        }

        console.warn(`No list name available for ${window.location.href}`);

        return UNKNOWN_LIST_NAME;
    }

    addOnClickTrackingHandler() {
        try {
            const dataNode: HTMLDivElement = this.querySelector(`[${DATA_TRACKING_ATTRIBUTE_NAME}]`);
            const dataString = dataNode.dataset[TRACKING_NAME];
            const list = this.getListName();

            if (!dataString) {
                throw new Error(`Couldn't find attribute ${TRACKING_NAME} in ${dataNode}`);
            }

            dataNode.addEventListener('click', () => {
                const data: TrackProductClickConfigProductWithPrices = JSON.parse(dataString);
                const products = buildConfigProduct(data);
                pushProductClickToDataLayer({ actionField: { list }, products });
            });
        } catch (e) {
            console.error(e);
        }
    }

    addOnClickPersistScrollTopHandler() {
        this.addEventListener('click', () => setScrollCommand({
            scrollPos: document.body.scrollTop,
            url: window.location.href
        }));
    }

    init() {
        this.addOnClickTrackingHandler();
        this.addOnClickPersistScrollTopHandler();
    }
}
